/**
 * Licensed Materials - Property of IBM
 * IBM Business Analytics (C) Copyright IBM Corp. 2019
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */

/**
 * @class CanvasDnD
 * @hideconstructor
 *
 * @classdesc
 * Represents the drag and drop action within the dashboard canvas
 */
define([
	'../CanvasDnDAPI',
	'../../../../../lib/@waca/dashboard-common/dist/core/APIFactory'

], function (
	CanvasDnDAPI,
	APIFactory
) {

	const PIN = 'pin';
	const WIDGET = 'widget';
	const GROUP_CONTENT ='groupContent';//this type occurs when grouped a few widgets into a single group, select a group, click on one of the widget within the group to select it and move it. When move it the type is 'groupContent'

	const DASHBOARD_DND_TYPES = [
		PIN,
		WIDGET
	];

	return class CanvasDnD {

		constructor() {
			this._api = APIFactory.createAPI(this, [CanvasDnDAPI]);
			this.providers = [];
		}

		destroy () {
			this.api = null;
			this.providers = [];
		}

		getAPI() {
			return this._api;
		}

		registerProvider(provider) {
			const registered = this.providers.find(registeredProvider => {
				return registeredProvider.getImplType() === provider.getImplType();
			});

			if ((typeof registered === 'undefined') || (registered === null)) {
				this.providers.push(provider);
			}
		}

		accepts (payload = {}, options = {}) {
			const types = this._getSupportedTypes(options);

			if (types.includes(payload.type)) {
				return true;
			}

			const providerAccepted = this.providers.find(provider => {
				return provider.accepts(payload, options);
			});

			return providerAccepted ? true : false;
		}

		onDrop (payload = {}) {
			if (payload.data && payload.data.operation === 'new') {
				return Promise.resolve(payload.data.model);
			}

			let promise = Promise.resolve();
			this.providers.forEach(provider => {
				promise = promise
					.then((model) => {
						return model ? model : provider.onDrop(payload);
					});
			});

			return promise;
		}

		_getSupportedTypes (options) {
			if (options && options.fromMultipurposeWidget) {
				return [];
			}

			const types = [
				...DASHBOARD_DND_TYPES
			];

			if (options && options.fromCanvas) {
				types.push(GROUP_CONTENT);
			}

			return types;
		}
	};
});
